import { Component, input } from '@angular/core';

@Component({
  selector: 'uw-skeleton',
  standalone: true,
  template: `
    <div
      class="animate-pulse rounded-md bg-surface-sunken"
      [class]="classes[rounded()]"
      [attr.aria-hidden]="'true'"
      [style.width]="width()"
      [style.height]="height()"
    ></div>
  `,
})
export class UwSkeleton {
  readonly width = input<string>('100%');
  readonly height = input<string>('14px');
  readonly rounded = input<'sm' | 'md' | 'full'>('md');

  protected readonly classes = {
    sm: 'rounded',
    md: 'rounded-md',
    full: 'rounded-full',
  } as const;
}
